export interface CreateFlashMessageDto
{
    getId():string;
    getStatusMessage():string;
    getPlanName():string;
    getMsisdn():number;

    setId(id:string):void;
    setStatusMessage(statusMessage:string):void;
    setPlanName(planName:string):void;
    setMsisdn(msisdn:number):void;
}

export class CreateFlashMessageDtoImpl implements CreateFlashMessageDto
{
   
    private id :string;
    private statusMessage : string;
    private msisdn:number;
    private planName:string;

    getId(): string {
        return this.id;
    }
    getStatusMessage(): string {
        return this.statusMessage;
    }
    setId(id: string): void 
    {
        this.id = id;
    }
    setStatusMessage(statusMessage: string): void 
    {
        this.statusMessage = statusMessage;
    }
   
    getPlanName(): string 
    {
        return this.planName;
    }
    getMsisdn(): number 
    {
        return this.msisdn;
    }
    setPlanName(planName: string): void 
    {
        this.planName = planName;
    }
    setMsisdn(msisdn: number): void 
    {
        this.msisdn = msisdn;
    }
    
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/flashmessage/create/createflashmessagedto.tsx